import {
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useState, useEffect } from "react";

const SelectDropDown = ({ properties, value: externalValue, onChange }) => {
  // Initialize internal state only for uncontrolled usage
  const [internalValue, setInternalValue] = useState(
    () => externalValue ?? (properties.isMultiSelect ? [] : "")
  );

  // Sync internal state when externalValue changes (uncontrolled -> controlled)
  useEffect(() => {
    if (externalValue !== undefined) {
      // Component is controlled, ignore internal state
      return;
    }
    // Update internal state if default value changes (uncontrolled only)
    setInternalValue(properties.isMultiSelect ? [] : "");
  }, [properties.isMultiSelect]); // Only reset if multi-select prop changes

  const handleChange = (newValue) => {
    if (externalValue === undefined) {
      // Only update internal state if uncontrolled
      setInternalValue(newValue);
    }
    // Propagate change to parent
    onChange?.(newValue);
  };

  // Determine displayed value
  const value = externalValue !== undefined ? externalValue : internalValue;

  return (
    <>
      {properties.isAutoSelect ? (
        <Autocomplete
          multiple={properties.isMultiSelect}
          size="small"
          options={properties.options || []}
          value={value}
          onChange={(_, newValue) => handleChange(newValue)}
          getOptionLabel={(option) => option}
          renderInput={(params) => (
            <TextField
              required={properties.required}
              {...params}
              label={properties.label}
              variant="outlined"
            />
          )}
        />
      ) : (
        <FormControl required={properties.required} fullWidth size="small">
          <InputLabel>{properties.label}</InputLabel>
          <Select
            value={value}
            onChange={(event) => handleChange(event.target.value)}
            label={properties.label}
          >
            {properties.options?.map((option, index) => (
              <MenuItem key={index} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </>
  );
};

export default SelectDropDown;
